import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "c-sitemenu",
  "aria-label": "Site menu"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "c-sitemenu__burger" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-sitemenu__burger-bar c-sitemenu__burger-bar--first" }),
  /*#__PURE__*/_createElementVNode("span", { class: "c-sitemenu__burger-bar c-sitemenu__burger-bar--second" }),
  /*#__PURE__*/_createElementVNode("span", { class: "c-sitemenu__burger-bar c-sitemenu__burger-bar--third" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_site_menu_overlay = _resolveComponent("site-menu-overlay")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", {
      class: "c-sitemenu__menu",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.open && $options.open(...args)))
    }, _hoisted_3),
    _createVNode(_component_site_menu_overlay, {
      "is-open": _ctx.isOpen,
      placement: "right",
      onClose: $options.close,
      class: "c-sitemenu"
    }, {
      header: _withCtx(() => [
        _renderSlot(_ctx.$slots, "header")
      ]),
      body: _withCtx(() => [
        _renderSlot(_ctx.$slots, "body")
      ]),
      _: 3
    }, 8, ["is-open", "onClose"])
  ]))
}